import { Entity, SystemEntity } from '@backstage/catalog-model';
import { EntityTable } from '@backstage/plugin-catalog-react';
import { TableColumn } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import Typography from '@material-ui/core/Typography';
import { InfoCard, Progress, ResponseErrorPanel } from '@backstage/core-components';
import { useFilteredEntityChildren } from '../Hooks'

const entityColumns: TableColumn<SystemEntity>[] = [
    EntityTable.columns.createEntityRefColumn({ defaultKind: 'system' }),
    EntityTable.columns.createOwnerColumn(),
    EntityTable.columns.createMetadataDescriptionColumn(),
  ];

export function SystemsTable() {
    const { loading, error, value }  = useFilteredEntityChildren( (entity: Entity) => entity.kind === 'System');    
    const { entity } = useEntity<Entity>();

    const title="Contained Systems";
    const variant="gridItem"

    if (loading) {
        return (
            <InfoCard variant={variant} title={title}>
                <Progress />
            </InfoCard>
        );
    }

    if (error) {
        return (
            <InfoCard variant={variant} title={title}>
            <ResponseErrorPanel error={error} />
            </InfoCard>
        );
    }

    return (
        <EntityTable
            title={title}
            variant={variant}
            emptyContent={
            <div style={{ textAlign: 'center' }}>
                <Typography variant="body1">
                    {entity.metadata.title ? entity.metadata.title : entity.metadata.name} does not contain any Systems
                </Typography>
            </div>
            }
            columns={entityColumns}
            entities={value as SystemEntity[]}
      />
    )
};
